import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg shadow-md p-6" }
const _hoisted_2 = { class: "mb-2 flex justify-end items-center" }
const _hoisted_3 = { class: "w-64" }
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  ref: "tableContainer",
  class: "overflow-auto",
  style: {"max-height":"300px","border":"1px solid #e5e7eb","border-radius":"0.375rem"}
}
const _hoisted_6 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_7 = { class: "bg-gray-50 sticky top-0 z-10" }
const _hoisted_8 = {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
}
const _hoisted_9 = { class: "text-xs font-normal text-gray-400 ml-2 lowercase" }
const _hoisted_10 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["data-id"]
const _hoisted_14 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_15 = { class: "px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" }
const _hoisted_16 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_17 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_18 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_19 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_20 = {
  key: 0,
  class: "px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
}
const _hoisted_21 = {
  key: 1,
  class: "px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800"
}
const _hoisted_22 = { class: "px-6 py-4 whitespace-nowrap text-sm font-medium" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "mt-8 bg-gray-50 p-6 rounded-md" }
const _hoisted_26 = { class: "text-lg font-medium mb-4" }
const _hoisted_27 = { class: "mb-6" }
const _hoisted_28 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_29 = {
  key: 0,
  class: "mt-1 text-sm text-red-500"
}
const _hoisted_30 = ["value"]
const _hoisted_31 = {
  key: 2,
  class: "mt-1 text-sm text-red-500"
}
const _hoisted_32 = ["value"]
const _hoisted_33 = {
  key: 0,
  class: "mt-1 text-sm text-red-500"
}
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "mb-4" }
const _hoisted_36 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_37 = { class: "mt-1" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = {
  key: 0,
  class: "text-xs text-gray-500 mt-1"
}
const _hoisted_40 = {
  key: 1,
  class: "mt-1 text-sm text-red-500"
}
const _hoisted_41 = { class: "mt-2 flex items-center" }
const _hoisted_42 = { class: "mt-6 flex justify-between items-center" }
const _hoisted_43 = { class: "flex space-x-3" }
const _hoisted_44 = ["disabled", "title"]
const _hoisted_45 = { class: "mt-8 flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[33] || (_cache[33] = _createElementVNode("div", { class: "mb-6" }, [
      _createElementVNode("h3", { class: "text-xl font-medium mb-2" }, "Due Date Management"),
      _createElementVNode("p", { class: "text-gray-500 mb-4" }, " Configure due dates for different actions and document types in the system. ")
    ], -1)),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _cache[10] || (_cache[10] = _createElementVNode("label", {
          for: "forecast-filter",
          class: "mr-2 text-sm font-medium text-gray-700"
        }, "Filter by Forecasting Process:", -1)),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("select", {
            id: "forecast-filter",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedForecastFilter) = $event)),
            class: "block w-full pl-3 pr-10 py-1 text-sm border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 rounded-md"
          }, [
            _cache[9] || (_cache[9] = _createElementVNode("option", { value: "" }, "All Forecasting Processes", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forecastingProcesses, (process) => {
              return (_openBlock(), _createElementBlock("option", {
                key: process.id,
                value: process.id
              }, _toDisplayString(process.name), 9, _hoisted_4))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.selectedForecastFilter]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _createElementVNode("thead", _hoisted_7, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_8, [
                _cache[11] || (_cache[11] = _createTextVNode(" Forecasting Process ")),
                _createElementVNode("span", _hoisted_9, " (" + _toDisplayString(_ctx.filteredDueDates.length) + " of " + _toDisplayString(_ctx.dueDates.length) + " entries) ", 1)
              ]),
              _cache[12] || (_cache[12] = _createElementVNode("th", {
                scope: "col",
                class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              }, "Action", -1)),
              _cache[13] || (_cache[13] = _createElementVNode("th", {
                scope: "col",
                class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              }, "Document Type", -1)),
              _cache[14] || (_cache[14] = _createElementVNode("th", {
                scope: "col",
                class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              }, "Absolute Date", -1)),
              _cache[15] || (_cache[15] = _createElementVNode("th", {
                scope: "col",
                class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              }, "Relative Hours", -1)),
              _cache[16] || (_cache[16] = _createElementVNode("th", {
                scope: "col",
                class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              }, "Consider Workdays", -1)),
              _cache[17] || (_cache[17] = _createElementVNode("th", {
                scope: "col",
                class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              }, "Actions", -1))
            ])
          ]),
          _createElementVNode("tbody", _hoisted_10, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_11, _cache[18] || (_cache[18] = [
                  _createElementVNode("td", {
                    colspan: "7",
                    class: "px-6 py-4 text-center text-gray-500"
                  }, " Loading due date configurations... ", -1)
                ])))
              : (_ctx.filteredDueDates.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_12, _cache[19] || (_cache[19] = [
                    _createElementVNode("td", {
                      colspan: "7",
                      class: "px-6 py-4 text-center text-gray-500"
                    }, " No due date configurations found. Add one below. ", -1)
                  ])))
                : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDueDates, (dueDate, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                class: "hover:bg-gray-50 transition-colors duration-300",
                "data-id": dueDate.id
              }, [
                _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.getForecastName(dueDate.forecast_id) || 'Not assigned'), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(dueDate.action), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(dueDate.document_type || 'All Types'), 1),
                _createElementVNode("td", _hoisted_17, _toDisplayString(dueDate.absolute ? _ctx.formatDateTime(dueDate.absolute) : 'Not set'), 1),
                _createElementVNode("td", _hoisted_18, _toDisplayString(dueDate.relative_hours) + " hours ", 1),
                _createElementVNode("td", _hoisted_19, [
                  (dueDate.consider_workdays)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, " Yes "))
                    : (_openBlock(), _createElementBlock("span", _hoisted_21, " No "))
                ]),
                _createElementVNode("td", _hoisted_22, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.editDueDate(dueDate)),
                    class: "text-indigo-600 hover:text-indigo-900 mr-3"
                  }, "Edit", 8, _hoisted_23),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.deleteDueDate(dueDate.id)),
                    class: "text-red-600 hover:text-red-900"
                  }, "Delete", 8, _hoisted_24)
                ])
              ], 8, _hoisted_13))
            }), 128))
          ])
        ])
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("h4", _hoisted_26, _toDisplayString(_ctx.isEditing ? 'Edit' : 'Add') + " Due Date Configuration", 1),
      _createElementVNode("form", {
        onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveDueDate && _ctx.saveDueDate(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", null, [
              _cache[21] || (_cache[21] = _createElementVNode("label", {
                for: "forecast_id",
                class: "block text-sm font-medium text-gray-700"
              }, [
                _createTextVNode(" Forecasting Process "),
                _createElementVNode("span", { class: "text-red-500" }, "*")
              ], -1)),
              (_ctx.forecastingProcesses.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, " No forecasting processes available. Please create a forecasting process first. "))
                : _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 1,
                    id: "forecast_id",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.forecast_id) = $event)),
                    class: _normalizeClass(["mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md", {'border-red-300 focus:ring-red-500 focus:border-red-500': !_ctx.formData.forecast_id && _ctx.formTouched}]),
                    required: ""
                  }, [
                    _cache[20] || (_cache[20] = _createElementVNode("option", { value: "" }, "Select a forecasting process", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forecastingProcesses, (process) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: process.id,
                        value: process.id
                      }, _toDisplayString(process.name) + " (" + _toDisplayString(_ctx.formatDate(process.start_date)) + ") ", 9, _hoisted_30))
                    }), 128))
                  ], 2)), [
                    [_vModelSelect, _ctx.formData.forecast_id]
                  ]),
              (!_ctx.formData.forecast_id && _ctx.formTouched && _ctx.forecastingProcesses.length > 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_31, " Forecasting Process is required "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _cache[23] || (_cache[23] = _createElementVNode("label", {
                for: "action",
                class: "block text-sm font-medium text-gray-700"
              }, [
                _createTextVNode(" Action "),
                _createElementVNode("span", { class: "text-red-500" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("select", {
                id: "action",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.action) = $event)),
                class: _normalizeClass(["mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md", {'border-red-300 focus:ring-red-500 focus:border-red-500': !_ctx.formData.action && _ctx.formTouched}]),
                required: ""
              }, [
                _cache[22] || (_cache[22] = _createElementVNode("option", { value: "" }, "Select an action", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actionOptions, (action) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: action,
                    value: action
                  }, _toDisplayString(action), 9, _hoisted_32))
                }), 128))
              ], 2), [
                [_vModelSelect, _ctx.formData.action]
              ]),
              (!_ctx.formData.action && _ctx.formTouched)
                ? (_openBlock(), _createElementBlock("p", _hoisted_33, " Action is required "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _cache[25] || (_cache[25] = _createElementVNode("label", {
                for: "document_type",
                class: "block text-sm font-medium text-gray-700"
              }, "Document Type", -1)),
              _withDirectives(_createElementVNode("select", {
                id: "document_type",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.document_type) = $event)),
                class: "mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
              }, [
                _cache[24] || (_cache[24] = _createElementVNode("option", { value: "" }, "All Types", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentTypeOptions, (type) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: type,
                    value: type
                  }, _toDisplayString(type), 9, _hoisted_34))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.formData.document_type]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", null, [
              _cache[27] || (_cache[27] = _createElementVNode("label", {
                for: "absolute_date",
                class: "block text-sm font-medium text-gray-700"
              }, "Absolute Date", -1)),
              _createElementVNode("div", _hoisted_37, [
                _withDirectives(_createElementVNode("input", {
                  type: "datetime-local",
                  id: "absolute_date",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.absolute) = $event)),
                  class: "focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                }, null, 512), [
                  [_vModelText, _ctx.formData.absolute]
                ]),
                _cache[26] || (_cache[26] = _createElementVNode("p", { class: "text-xs text-gray-500 mt-1" }, " If set, this exact date will be used instead of calculating from relative hours. ", -1))
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[28] || (_cache[28] = _createElementVNode("label", {
                for: "relative_hours",
                class: "block text-sm font-medium text-gray-700"
              }, " Relative Hours ", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                id: "relative_hours",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.relative_hours) = $event)),
                min: "1",
                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {'border-red-300 focus:ring-red-500 focus:border-red-500': !_ctx.formData.relative_hours && !_ctx.formData.absolute && _ctx.formTouched}]),
                disabled: !!_ctx.formData.absolute && _ctx.formData.absolute.trim() !== ''
              }, null, 10, _hoisted_38), [
                [
                  _vModelText,
                  _ctx.formData.relative_hours,
                  void 0,
                  { number: true }
                ]
              ]),
              (!!_ctx.formData.absolute && _ctx.formData.absolute.trim() !== '')
                ? (_openBlock(), _createElementBlock("p", _hoisted_39, " Disabled when absolute date is set. "))
                : (!_ctx.formData.relative_hours && !_ctx.formData.absolute && _ctx.formTouched)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_40, " Either Relative Hours or Absolute Date is required "))
                  : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _cache[30] || (_cache[30] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Consider Workdays", -1)),
              _createElementVNode("div", _hoisted_41, [
                _withDirectives(_createElementVNode("input", {
                  id: "consider_workdays",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.consider_workdays) = $event)),
                  class: "h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.formData.consider_workdays]
                ]),
                _cache[29] || (_cache[29] = _createElementVNode("label", {
                  for: "consider_workdays",
                  class: "ml-2 block text-sm text-gray-700"
                }, " Skip Weekends ", -1))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _cache[31] || (_cache[31] = _createElementVNode("p", { class: "text-sm text-gray-500" }, [
            _createTextVNode("Fields marked with "),
            _createElementVNode("span", { class: "text-red-500" }, "*"),
            _createTextVNode(" are required")
          ], -1)),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args))),
              class: "px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            }, " Cancel "),
            _createElementVNode("button", {
              type: "submit",
              class: "px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
              disabled: _ctx.forecastingProcesses.length === 0 || !_ctx.isFormValid,
              title: !_ctx.isFormValid ? 'Please fill in all required fields' : ''
            }, _toDisplayString(_ctx.isEditing ? 'Update' : 'Add') + " Due Date ", 9, _hoisted_44)
          ])
        ])
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_45, [
      _createVNode(_component_router_link, {
        to: "/administration",
        class: "px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-600 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 inline-block"
      }, {
        default: _withCtx(() => _cache[32] || (_cache[32] = [
          _createTextVNode(" Return to Administration ")
        ])),
        _: 1,
        __: [32]
      })
    ])
  ]))
}